exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".work-order-tempate .flow-item[data-v-166919a2]{margin-bottom:10px}.work-order-tempate .flow-remove-icon[data-v-166919a2]{font-size:18px;margin-top:8px}.work-order-tempate .flow-remove-icon[data-v-166919a2]:hover{cursor:pointer}.work-order-tempate .flow-add-btn[data-v-166919a2]{width:343px;height:36px;line-height:36px;text-align:center;color:#8c939d;border:1px dashed #d9d9d9;border-radius:4px}.work-order-tempate .flow-add-btn .flow-plus-icon[data-v-166919a2]{font-size:12px;margin-right:5px}.work-order-tempate .flow-add-btn[data-v-166919a2]:hover{cursor:pointer;color:#409EFF;border-color:#409EFF}\n", ""]);

// exports
